import { useState } from "react";
import type { ReaderWorkspace } from "../reader/reader-workspace";
import { SearchResultList } from "../components/features/search/search-result-list";
import { SearchToolbar } from "../components/features/search/search-toolbar";
import { SearchResultDetailDialog } from "./search-result-detail-dialog";

export function SearchPage({ workspace }: { workspace: ReaderWorkspace }) {
  const [detailBookId, setDetailBookId] = useState<string | null>(null);
  const hasResults = workspace.results.length > 0;
  const detailResult = detailBookId ? workspace.results.find(result => result.book.id === detailBookId) ?? null : null;

  return (
    <div className="space-y-4">
      <SearchToolbar
        busy={workspace.busy}
        hasResults={hasResults}
        message={workspace.searchMessage}
        query={workspace.query}
        resultCount={workspace.results.length}
        searching={workspace.searching}
        userAvailable={Boolean(workspace.user)}
        onQueryChange={workspace.setQuery}
        onSearch={() => void workspace.handleSearch()}
        onStopSearch={workspace.handleStopSearch}
      />

      <section>
        <SearchResultList
          emptyText={resolveSearchEmptyText(workspace.query, workspace.searchMessage, workspace.searching)}
          results={workspace.results}
          onSelect={setDetailBookId}
        />
      </section>

      {detailResult && (
        <SearchResultDetailDialog
          result={detailResult}
          workspace={workspace}
          onClose={() => setDetailBookId(null)}
        />
      )}
    </div>
  );
}

function resolveSearchEmptyText(query: string, message: string, searching: boolean): string {
  if (searching) return "正在搜索，查到后会逐条显示";
  if (message === "搜索已停止") return "搜索已停止";
  return query.trim().length > 0 ? "没有新的搜索结果，可以换个关键词试试" : "输入书名或作者后开始搜索";
}
